import React, { Text, View } from "react-native";
import { FONT, SESSIONSTORAGE } from "../../value/staticValues";

import DashboardTopBtn from "./component/DashboardTopBtn";
import { Fragment, useEffect, useState } from "react";
import { base64Decoding } from "../../common/util";

import InfraViewBox from "./viewBox/InfraViewBox";
import { DashboardContainer, DashboardInfra, DashboardProject } from "./DashboardContainer";
import ProjectViewBox from "./viewBox/ProjectViewBox";
import ContainerViewBox from "./viewBox/ContainerViewBox";
import { useTranslation } from "react-i18next";

export interface DashboardViewBoxProps {
    data: DashboardProps;
}

export interface DashboardProps {
    dashboardInfra: DashboardInfra;
    dashboardContainer: DashboardContainer;
    dashboardProject: DashboardProject;
    changeViewFunction: Function;
}

export default function Dashboard(props:DashboardProps) {
    const { t } = useTranslation();
    const [viewType, setViewType] = useState("");
    const userRole = base64Decoding(sessionStorage.getItem(SESSIONSTORAGE.USER_ROLE));

    useEffect(() => {
        props.changeViewFunction(viewType);
    }, [viewType]);

    useEffect(() => {
        if (userRole === "ADM") {
            setViewType("Infra View")
        } else {
            setViewType("Project View")
        }
    }, [userRole])


    return (
        <View style={{width: "100%", height: '100%', minHeight: "94vh", paddingLeft: 20, paddingTop: 16, paddingRight:15}}>
            <View style={{flexDirection: "row", alignItems: "center", marginBottom: 10}}>
                {userRole === "ADM" ?
                <Fragment>
                    <DashboardTopBtn
                        text={"Infra View"}
                        value={viewType}
                        setValue={setViewType}
                    />
                    <View style={{width:10}}/>
                </Fragment>
                : null
                }
                <Fragment>
                    <DashboardTopBtn
                        text={"Project View"}
                        value={viewType}
                        setValue={setViewType}
                    />
                    <View style={{width:10}}/>
                </Fragment>
                <DashboardTopBtn
                    text={"Container View"}
                    value={viewType}
                    setValue={setViewType}
                />
            </View>

            {viewType === "Infra View" ?
                <InfraViewBox data={props.dashboardInfra}/>
            : viewType === 'Project View' ?
                <ProjectViewBox data={props.dashboardProject}/>
            :
                <ContainerViewBox data={props.dashboardContainer}/>
            }
            <View style={{marginTop: "auto", marginLeft: "auto", marginBottom: 20}}>
                <Text style={{
                    fontFamily: FONT.REGULAR,
                    fontSize: 12,
                    color: "#b6bfce",
                    textAlign: "right"
                }}>
                    {t("BOTTOM_COPY_RIGHT_TEXT")}
                </Text>
            </View>
        </View>
    )
}
